import React from "react";
import { useNavigate } from "react-router-dom";
import "./navbar.css";
export default function Navbar() {
  let navigate = useNavigate();
  return (
    <div className="nav-wrapper">
      <div className="nav-box">
        <a href="https://www.brightpowersolutions.co.uk">
          <img
            className="nav-item bright-logo"
            src={"./imgs/brightlogo.png"}
            onClick={() => navigate("/")}
            alt=""
          />
        </a>
        <p className="nav-item slogan">Powered by common sense</p>
      </div>
      <div className="nav-box">
        <a href="https://www.brightpowersolutions.co.uk/about-bright"><div className="nav-item">About</div></a>
        <a href="https://www.brightpowersolutions.co.uk/sustainability">
          <div className="nav-item">Sustainability</div>
        </a>
        <a href="https://www.brightpowersolutions.co.uk/contact">
          <div className="nav-item">Contact</div>
        </a>
      </div>
    </div>
  );
}
